import request from './base'

export const getWorkOrderList = (data) => {
    return request.post("/admin/v1/workorder/list", data)
}

export const updateWorkOrder = (data) => {
    return request.post("/admin/v1/workorder/update", data)
}

export const getDownloadUrl = (data) => {
    return request.post("/admin/v1/workorder/getDownloadUrl", data)
}

// 续费订单列表
export const rechargeList = (data) => {
    return request.post("/admin/v1/workorder/rechargeList", data)
}





// WEBPACK FOOTER //
// ./src/api/workorder.js